export const heroData = {
  title: '注册送彩金',
  subtitle: '立即注册领取专属彩金福利',
  description: '注册送彩金活动火热进行中！新用户完成注册即可免费领取专属彩金，无需存款即可体验，彩金可用于游戏下注，名额有限先到先得。',
  ctaText: '立即注册领取',
  ctaSubtext: '已有超过 128,000+ 用户领取彩金',
};

export const featuresData = [
  {
    id: 1,
    icon: 'ri-gift-line',
    title: '免费注册即送',
    description: '新用户完成简单注册流程，无需任何存款要求，系统自动发放专属彩金到您的账户。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '秒级到账体验',
    description: '注册成功后彩金即时到账，无需等待审核，即可立即在游戏中体验彩金带来的乐趣。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '安全可靠保障',
    description: '平台采用银行级加密技术，严格保护用户信息和资金安全，让您放心游戏无忧。',
  },
  {
    id: 4,
    icon: 'ri-customer-service-2-line',
    title: '7×24小时客服',
    description: '专业客服团队全天候在线，随时解答您的疑问，提供最贴心的服务体验。',
  },
  {
    id: 5,
    icon: 'ri-smartphone-line',
    title: '多端畅玩体验',
    description: '支持电脑、手机、平板多端同步，随时随地畅享游戏乐趣，彩金福利同步享受。',
  },
  {
    id: 6,
    icon: 'ri-vip-crown-line',
    title: 'VIP专属福利',
    description: '成为VIP会员享受更多专属彩金福利，高额返水、生日礼金、专属客服等特权等您来。',
  },
];

export const statsData = [
  { id: 1, value: '128,000+', label: '累计注册用户' },
  { id: 2, value: '¥5,680万+', label: '已发放彩金总额' },
  { id: 3, value: '99.7%', label: '用户满意度' },
  { id: 4, value: '30秒', label: '最快到账时间' },
];

export const faqData = [
  {
    id: 1,
    question: '什么是注册送彩金活动？',
    answer: '注册送彩金活动是针对新用户推出的专属福利活动，新用户完成注册后，系统会自动发放一定金额的彩金到账户中。彩金无需存款即可领取，可用于参与平台上的各类游戏，是平台为新用户准备的见面礼。',
  },
  {
    id: 2,
    question: '如何领取注册彩金？',
    answer: '领取流程非常简单：第一步，点击网站上的"立即注册"按钮；第二步，填写基本信息完成账号注册；第三步，完成手机号或邮箱验证；第四步，彩金自动发放到您的账户。整个流程仅需2-3分钟即可完成。',
  },
  {
    id: 3,
    question: '彩金有使用限制吗？',
    answer: '彩金使用有一定规则：彩金需在领取后30天内使用，达到指定流水倍数后可申请提现。具体的使用规则和流水要求会在彩金发放时详细说明，建议您仔细阅读活动规则。不同时期的活动规则可能略有差异。',
  },
  {
    id: 4,
    question: '一个人可以注册多个账号领取彩金吗？',
    answer: '为了维护活动公平性，每位用户仅限使用一个账号参与注册送彩金活动。平台采用严格的身份验证机制，同一手机号、同一设备、同一IP地址均视为同一用户。如发现违规行为，平台有权取消相关账号的彩金资格。',
  },
  {
    id: 5,
    question: '彩金可以提现吗？',
    answer: '可以的。彩金在完成规定的流水要求后，即可申请提现到您绑定的银行卡或电子钱包中。提现审核通常在1-2个工作日内完成，节假日可能会有延迟。建议您完善实名认证信息以提高提现审核通过速度。',
  },
  {
    id: 6,
    question: '活动有时间限制吗？',
    answer: '注册送彩金是平台长期进行的福利活动，但不同时期可能会有不同的彩金金额和规则调整。建议您关注平台公告和活动页面了解最新信息。目前正在进行中的活动名额有限，采用先到先得的方式发放。',
  },
];